<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col class="pt-10 text-center" cols="3">
            <!-- <v-file-input
                 v-model="currentImage"
       chips
       accept="image/*"
       label="Image"
       @change="onFileChange"
              /> -->
            <v-avatar size="200" max-height="100%" max-width="100%">
              <img
                alt="user"
                :src="user.imgURL ? user.imgURL : '/img/user.jpg'"
              />
              <!-- <img
                alt="user"
                :src="user.imgURL"
              /> -->
              <v-file-input
                id="fileUpload"
                accept="image/*"
                hide-input
                @change="onFileChanged"
                prepend-icon=""
              />
              <!-- <input
            ref="uploader" 
            class="d-none" 
            type="file" 
            @change="onFileChanged"
        /> -->
            </v-avatar>

            <!-- <v-btn
          class="btn btn-success btn-sm float-right"
          :disabled="!currentImage"
          color="primary"
          @click="upload"
        >
          Upload
            </v-btn> -->
            <!-- <v-btn 
            color="primary" 
            rounded 
            dark 
            :loading="isSelecting" 
            @click="handleFileImport"
        >
            Upload File
        </v-btn> -->
            <v-btn color="primary" rounded dark @click="getFile">
              {{ $t('uploadImage') }}
            </v-btn>
            <div v-if="currentImage" class="progress">
              <div
                class="progress-bar progress-bar-info"
                role="progressbar"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: progress + '%' }"
              >
                {{ progress }}%
              </div>
            </div>
            <!-- <p class="text-center mt-2">
              {{ user.name }}
            </p> -->
          </v-col>

          <v-col cols="9">
            <v-form
              ref="profile_form"
              v-model="valid"
              lazy-validation
              @submit.prevent="updateProfile"
            >
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('name')}}</label
                      >
                      <v-text-field
                        v-model="user.name"
                        outlined
                        dense
                        :rules="rules.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('email')}}</label
                      >
                      <v-text-field
                        v-model="user.email"
                        outlined
                        dense
                        :rules="rules.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('mobile')}}</label
                      >
                      <v-text-field
                        v-model="user.mobile"
                        outlined
                        dense
                        :rules="rules.phone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('role')}}</label
                      >
                      <v-text-field
                        v-model="user.role"
                        outlined
                        disabled
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('department')}}</label
                      >
                      <v-text-field
                        v-model="user.department"
                        outlined
                        disabled
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      type="submit"
                      :disabled="profileChange && valid"
                      right
                      height="44"
                      width="116"
                      color="primary"
                    >
                      {{$t('update')}}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="errorDialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>

        <v-card-text>
          {{ errorText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text @click="errorDialog = false">
            {{$t('cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
import ProfileService from "../../_services/ProfileService";
import axios from "axios";

export default {
  created() {
    this.getProfileData();
  },
  computed: {
    profileChange() {
      return (
        this.user.name == this.orgUser.name &&
        this.user.email == this.orgUser.email &&
        this.user.mobile == this.orgUser.mobile &&
        this.user.imgURL == this.orgUser.imgURL
      );
    },
  },
  data: () => ({
    valid: true,
    isSelecting: false,
    selectedFile: null,
    errorDialog: false,
    errorText: "",
    orgUser: {},
    currentImage: undefined,
    //   previewImage: undefined,
    progress: 0,
    //   message: "",
    imageInfos: [],
    user: {
      name: "",
      email: "",
      mobile: "",
      department: "",
      profilePicUrl: "",
      role: "",
      userName: "",
      imgURL: "",
    },
    rules: {
      name: [(v) => !!v.match(/^[a-zA-Z\s]+$/) || 'Only alphabets are allowed'],
      email: [
        (v) =>
          !!v.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Invalid Email",
      ],
      phone: [(v) => v.length == 10 || 'Phone should have 10 characters'],
    },
  }),
  methods: {
    getProfileData() {
      this.startLoading();

      ProfileService.getProfileData()
        .then(async (res) => {
          if (res.success) {
              // console.log(res)
            for (var k in res.data) this.user[k] = res.data[k];
            
            try{
              const d = await axios.get(this.user.imgURL)
              console.log('image', d)
            }catch(e) {
              console.log('image', e)
              this.user.imgURL = '/img/user.jpg'
            }
            this.orgUser = res.data;
            console.log("get",this.orgUser)
          }
          this.stopLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("/login");
          this.stopLoading();
        });
    },
    getFile() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    onFileChanged(filename) {
      this.selectedFile = filename;
      if (this.selectedFile) {
        let size = this.selectedFile.size;
        console.log(size);
        if (!this.selectedFile.type.match("image.*")) {
          // check whether the upload is an image
          this.errorDialog = true;
          this.errorText = this.$t("pleaseChooseAnImageFile");
        } else if (size > 4000000) {
          // check whether the size is greater than the size limit
          this.errorDialog = true;
          this.errorText =
            this.$t("fileIsTooBigSelectUnder1MB");
        } else {
          // Append file into FormData & turn file into image URL
          let formData = new FormData();
          // let imageURL = URL.createObjectURL(this.selectedFile)
          // console.log("url",imageURL)
          formData.append("profile", this.selectedFile);
          this.startLoading();
          ProfileService.imageUpdate(formData)
            .then(async (res) => {
              console.log(res);
              if (res.success) {
                this.user.imgURL = res.data.image.imgURL;
                console.log(this.user.imgURL);
                this.$notify({
                  title: this.$t("imageUpdated"),
                  text: ``,
                  type: "success",
                });
              }
              // this.getProfileData()
              this.stopLoading();
            })
            .catch(() => {
              this.$notify({
                title: this.$t('somethingWentWrong'),
                text: this.$t('pleaseTryAgainAfterSometime'),
                type: "error",
              });
              this.stopLoading();
            });
        }
      }
    },
    updateProfile() {
      if (!this.$refs.profile_form.validate()) return;
      if (
        this.user.name == this.orgUser.name &&
        this.user.email == this.orgUser.email &&
        this.user.mobile == this.orgUser.mobile
      ) {
        this.$notify({
          title:this.$t('nothingchanged'),
          text: ``,
          type: "error",
        });
        return;
      }
      this.startLoading();
      const { name, email, mobile } = this.user;
      ProfileService.updateProfileData({ name, email, mobile })
        .then((res) => {
          console.log(res);
          this.$notify({
            title: this.$t("profileUpdated"),
            text: ``,
            type: "success",
          });
          this.stopLoading();
        })
        // "http://3.218.20.78:3002/api/user/profile/img/45bff962-8b38-4daa-ad2d-f1ef9c9c5e0f.jpg"
        .catch(() => {
          this.$notify({
            title: this.$t('somethingWentWrong'),
            text: this.$t('pleaseTryAgainAfterSometime'),
            type: "error",
          });
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
};
</script>